/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendBusinessAngelDto } from '../models/backend-business-angel-dto';
import { BackendBusinessAngelDividendDto } from '../models/backend-business-angel-dividend-dto';
import { BackendBusinessAngelLoanDto } from '../models/backend-business-angel-loan-dto';
import { BackendBusinessAngelVariantDto } from '../models/backend-business-angel-variant-dto';
import { BackendPaginatedBusinessAngelDividendListDto } from '../models/backend-paginated-business-angel-dividend-list-dto';
import { BackendPaginatedBusinessAngelListDto } from '../models/backend-paginated-business-angel-list-dto';
import { BackendPaginatedBusinessAngelLoanListDto } from '../models/backend-paginated-business-angel-loan-list-dto';
import { BackendPaginatedBusinessAngelVariantListDto } from '../models/backend-paginated-business-angel-variant-list-dto';
import { ventureFundsBusinessAngelDividendsCreate } from '../fn/business-angel/venture-funds-business-angel-dividends-create';
import { ventureFundsBusinessAngelDividendsCreate$FormData } from '../fn/business-angel/venture-funds-business-angel-dividends-create-form-data';
import { VentureFundsBusinessAngelDividendsCreate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-create-form-data';
import { VentureFundsBusinessAngelDividendsCreate$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-create';
import { ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-dividends-create-x-www-form-urlencoded';
import { VentureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-create-x-www-form-urlencoded';
import { ventureFundsBusinessAngelDividendsDestroy } from '../fn/business-angel/venture-funds-business-angel-dividends-destroy';
import { VentureFundsBusinessAngelDividendsDestroy$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-destroy';
import { ventureFundsBusinessAngelDividendsList } from '../fn/business-angel/venture-funds-business-angel-dividends-list';
import { VentureFundsBusinessAngelDividendsList$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-list';
import { ventureFundsBusinessAngelDividendsPartialUpdate } from '../fn/business-angel/venture-funds-business-angel-dividends-partial-update';
import { ventureFundsBusinessAngelDividendsPartialUpdate$FormData } from '../fn/business-angel/venture-funds-business-angel-dividends-partial-update-form-data';
import { VentureFundsBusinessAngelDividendsPartialUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-partial-update-form-data';
import { VentureFundsBusinessAngelDividendsPartialUpdate$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-partial-update';
import { ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-dividends-partial-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-partial-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelDividendsRetrieve } from '../fn/business-angel/venture-funds-business-angel-dividends-retrieve';
import { VentureFundsBusinessAngelDividendsRetrieve$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-retrieve';
import { ventureFundsBusinessAngelDividendsUpdate } from '../fn/business-angel/venture-funds-business-angel-dividends-update';
import { ventureFundsBusinessAngelDividendsUpdate$FormData } from '../fn/business-angel/venture-funds-business-angel-dividends-update-form-data';
import { VentureFundsBusinessAngelDividendsUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-update-form-data';
import { VentureFundsBusinessAngelDividendsUpdate$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-update';
import { ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-dividends-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-dividends-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelLoansCreate } from '../fn/business-angel/venture-funds-business-angel-loans-create';
import { ventureFundsBusinessAngelLoansCreate$FormData } from '../fn/business-angel/venture-funds-business-angel-loans-create-form-data';
import { VentureFundsBusinessAngelLoansCreate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-loans-create-form-data';
import { VentureFundsBusinessAngelLoansCreate$Params } from '../fn/business-angel/venture-funds-business-angel-loans-create';
import { ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-loans-create-x-www-form-urlencoded';
import { VentureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-loans-create-x-www-form-urlencoded';
import { ventureFundsBusinessAngelLoansDestroy } from '../fn/business-angel/venture-funds-business-angel-loans-destroy';
import { VentureFundsBusinessAngelLoansDestroy$Params } from '../fn/business-angel/venture-funds-business-angel-loans-destroy';
import { ventureFundsBusinessAngelLoansList } from '../fn/business-angel/venture-funds-business-angel-loans-list';
import { VentureFundsBusinessAngelLoansList$Params } from '../fn/business-angel/venture-funds-business-angel-loans-list';
import { ventureFundsBusinessAngelLoansPartialUpdate } from '../fn/business-angel/venture-funds-business-angel-loans-partial-update';
import { ventureFundsBusinessAngelLoansPartialUpdate$FormData } from '../fn/business-angel/venture-funds-business-angel-loans-partial-update-form-data';
import { VentureFundsBusinessAngelLoansPartialUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-loans-partial-update-form-data';
import { VentureFundsBusinessAngelLoansPartialUpdate$Params } from '../fn/business-angel/venture-funds-business-angel-loans-partial-update';
import { ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-loans-partial-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-loans-partial-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelLoansRetrieve } from '../fn/business-angel/venture-funds-business-angel-loans-retrieve';
import { VentureFundsBusinessAngelLoansRetrieve$Params } from '../fn/business-angel/venture-funds-business-angel-loans-retrieve';
import { ventureFundsBusinessAngelLoansUpdate } from '../fn/business-angel/venture-funds-business-angel-loans-update';
import { ventureFundsBusinessAngelLoansUpdate$FormData } from '../fn/business-angel/venture-funds-business-angel-loans-update-form-data';
import { VentureFundsBusinessAngelLoansUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-loans-update-form-data';
import { VentureFundsBusinessAngelLoansUpdate$Params } from '../fn/business-angel/venture-funds-business-angel-loans-update';
import { ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-loans-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-loans-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelsCreate } from '../fn/business-angel/venture-funds-business-angels-create';
import { ventureFundsBusinessAngelsCreate$FormData } from '../fn/business-angel/venture-funds-business-angels-create-form-data';
import { VentureFundsBusinessAngelsCreate$FormData$Params } from '../fn/business-angel/venture-funds-business-angels-create-form-data';
import { VentureFundsBusinessAngelsCreate$Params } from '../fn/business-angel/venture-funds-business-angels-create';
import { ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angels-create-x-www-form-urlencoded';
import { VentureFundsBusinessAngelsCreate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angels-create-x-www-form-urlencoded';
import { ventureFundsBusinessAngelsDestroy } from '../fn/business-angel/venture-funds-business-angels-destroy';
import { VentureFundsBusinessAngelsDestroy$Params } from '../fn/business-angel/venture-funds-business-angels-destroy';
import { ventureFundsBusinessAngelsList } from '../fn/business-angel/venture-funds-business-angels-list';
import { VentureFundsBusinessAngelsList$Params } from '../fn/business-angel/venture-funds-business-angels-list';
import { ventureFundsBusinessAngelsPartialUpdate } from '../fn/business-angel/venture-funds-business-angels-partial-update';
import { ventureFundsBusinessAngelsPartialUpdate$FormData } from '../fn/business-angel/venture-funds-business-angels-partial-update-form-data';
import { VentureFundsBusinessAngelsPartialUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angels-partial-update-form-data';
import { VentureFundsBusinessAngelsPartialUpdate$Params } from '../fn/business-angel/venture-funds-business-angels-partial-update';
import { ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angels-partial-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angels-partial-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelsRetrieve } from '../fn/business-angel/venture-funds-business-angels-retrieve';
import { VentureFundsBusinessAngelsRetrieve$Params } from '../fn/business-angel/venture-funds-business-angels-retrieve';
import { ventureFundsBusinessAngelsUpdate } from '../fn/business-angel/venture-funds-business-angels-update';
import { ventureFundsBusinessAngelsUpdate$FormData } from '../fn/business-angel/venture-funds-business-angels-update-form-data';
import { VentureFundsBusinessAngelsUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angels-update-form-data';
import { VentureFundsBusinessAngelsUpdate$Params } from '../fn/business-angel/venture-funds-business-angels-update';
import { ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angels-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelsUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angels-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelVariantsCreate } from '../fn/business-angel/venture-funds-business-angel-variants-create';
import { ventureFundsBusinessAngelVariantsCreate$FormData } from '../fn/business-angel/venture-funds-business-angel-variants-create-form-data';
import { VentureFundsBusinessAngelVariantsCreate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-variants-create-form-data';
import { VentureFundsBusinessAngelVariantsCreate$Params } from '../fn/business-angel/venture-funds-business-angel-variants-create';
import { ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-variants-create-x-www-form-urlencoded';
import { VentureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-variants-create-x-www-form-urlencoded';
import { ventureFundsBusinessAngelVariantsDestroy } from '../fn/business-angel/venture-funds-business-angel-variants-destroy';
import { VentureFundsBusinessAngelVariantsDestroy$Params } from '../fn/business-angel/venture-funds-business-angel-variants-destroy';
import { ventureFundsBusinessAngelVariantsList } from '../fn/business-angel/venture-funds-business-angel-variants-list';
import { VentureFundsBusinessAngelVariantsList$Params } from '../fn/business-angel/venture-funds-business-angel-variants-list';
import { ventureFundsBusinessAngelVariantsPartialUpdate } from '../fn/business-angel/venture-funds-business-angel-variants-partial-update';
import { ventureFundsBusinessAngelVariantsPartialUpdate$FormData } from '../fn/business-angel/venture-funds-business-angel-variants-partial-update-form-data';
import { VentureFundsBusinessAngelVariantsPartialUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-variants-partial-update-form-data';
import { VentureFundsBusinessAngelVariantsPartialUpdate$Params } from '../fn/business-angel/venture-funds-business-angel-variants-partial-update';
import { ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-variants-partial-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-variants-partial-update-x-www-form-urlencoded';
import { ventureFundsBusinessAngelVariantsRetrieve } from '../fn/business-angel/venture-funds-business-angel-variants-retrieve';
import { VentureFundsBusinessAngelVariantsRetrieve$Params } from '../fn/business-angel/venture-funds-business-angel-variants-retrieve';
import { ventureFundsBusinessAngelVariantsUpdate } from '../fn/business-angel/venture-funds-business-angel-variants-update';
import { ventureFundsBusinessAngelVariantsUpdate$FormData } from '../fn/business-angel/venture-funds-business-angel-variants-update-form-data';
import { VentureFundsBusinessAngelVariantsUpdate$FormData$Params } from '../fn/business-angel/venture-funds-business-angel-variants-update-form-data';
import { VentureFundsBusinessAngelVariantsUpdate$Params } from '../fn/business-angel/venture-funds-business-angel-variants-update';
import { ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded } from '../fn/business-angel/venture-funds-business-angel-variants-update-x-www-form-urlencoded';
import { VentureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/business-angel/venture-funds-business-angel-variants-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiBusinessAngelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ventureFundsBusinessAngelDividendsList()` */
  static readonly VentureFundsBusinessAngelDividendsListPath = '/api/venture_funds/business-angel-dividends/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelDividendsList$Response(
    params?: VentureFundsBusinessAngelDividendsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelDividendListDto>> {
    return ventureFundsBusinessAngelDividendsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelDividendsList(
    params?: VentureFundsBusinessAngelDividendsList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedBusinessAngelDividendListDto> {
    return this.ventureFundsBusinessAngelDividendsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendPaginatedBusinessAngelDividendListDto>,
        ): BackendPaginatedBusinessAngelDividendListDto => r.body,
      ),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelDividendsCreate()` */
  static readonly VentureFundsBusinessAngelDividendsCreatePath = '/api/venture_funds/business-angel-dividends/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelDividendsCreate$Response(
    params: VentureFundsBusinessAngelDividendsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelDividendsCreate(
    params: VentureFundsBusinessAngelDividendsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelDividendsCreate$FormData$Response(
    params: VentureFundsBusinessAngelDividendsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelDividendsCreate$FormData(
    params: VentureFundsBusinessAngelDividendsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelDividendsRetrieve()` */
  static readonly VentureFundsBusinessAngelDividendsRetrievePath = '/api/venture_funds/business-angel-dividends/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelDividendsRetrieve$Response(
    params: VentureFundsBusinessAngelDividendsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelDividendsRetrieve(
    params: VentureFundsBusinessAngelDividendsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelDividendsUpdate()` */
  static readonly VentureFundsBusinessAngelDividendsUpdatePath = '/api/venture_funds/business-angel-dividends/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelDividendsUpdate$Response(
    params: VentureFundsBusinessAngelDividendsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelDividendsUpdate(
    params: VentureFundsBusinessAngelDividendsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelDividendsUpdate$FormData$Response(
    params: VentureFundsBusinessAngelDividendsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelDividendsUpdate$FormData(
    params: VentureFundsBusinessAngelDividendsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelDividendsDestroy()` */
  static readonly VentureFundsBusinessAngelDividendsDestroyPath = '/api/venture_funds/business-angel-dividends/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelDividendsDestroy$Response(
    params: VentureFundsBusinessAngelDividendsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsBusinessAngelDividendsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelDividendsDestroy(
    params: VentureFundsBusinessAngelDividendsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsBusinessAngelDividendsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelDividendsPartialUpdate()` */
  static readonly VentureFundsBusinessAngelDividendsPartialUpdatePath =
    '/api/venture_funds/business-angel-dividends/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelDividendsPartialUpdate$Response(
    params: VentureFundsBusinessAngelDividendsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelDividendsPartialUpdate(
    params: VentureFundsBusinessAngelDividendsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelDividendsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelDividendsPartialUpdate$FormData$Response(
    params: VentureFundsBusinessAngelDividendsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
    return ventureFundsBusinessAngelDividendsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelDividendsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelDividendsPartialUpdate$FormData(
    params: VentureFundsBusinessAngelDividendsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDividendDto> {
    return this.ventureFundsBusinessAngelDividendsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDividendDto>): BackendBusinessAngelDividendDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelLoansList()` */
  static readonly VentureFundsBusinessAngelLoansListPath = '/api/venture_funds/business-angel-loans/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelLoansList$Response(
    params?: VentureFundsBusinessAngelLoansList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelLoanListDto>> {
    return ventureFundsBusinessAngelLoansList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelLoansList(
    params?: VentureFundsBusinessAngelLoansList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedBusinessAngelLoanListDto> {
    return this.ventureFundsBusinessAngelLoansList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedBusinessAngelLoanListDto>): BackendPaginatedBusinessAngelLoanListDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelLoansCreate()` */
  static readonly VentureFundsBusinessAngelLoansCreatePath = '/api/venture_funds/business-angel-loans/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelLoansCreate$Response(
    params: VentureFundsBusinessAngelLoansCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelLoansCreate(
    params: VentureFundsBusinessAngelLoansCreate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelLoansCreate$FormData$Response(
    params: VentureFundsBusinessAngelLoansCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelLoansCreate$FormData(
    params: VentureFundsBusinessAngelLoansCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelLoansRetrieve()` */
  static readonly VentureFundsBusinessAngelLoansRetrievePath = '/api/venture_funds/business-angel-loans/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelLoansRetrieve$Response(
    params: VentureFundsBusinessAngelLoansRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelLoansRetrieve(
    params: VentureFundsBusinessAngelLoansRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelLoansUpdate()` */
  static readonly VentureFundsBusinessAngelLoansUpdatePath = '/api/venture_funds/business-angel-loans/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelLoansUpdate$Response(
    params: VentureFundsBusinessAngelLoansUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelLoansUpdate(
    params: VentureFundsBusinessAngelLoansUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelLoansUpdate$FormData$Response(
    params: VentureFundsBusinessAngelLoansUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelLoansUpdate$FormData(
    params: VentureFundsBusinessAngelLoansUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelLoansDestroy()` */
  static readonly VentureFundsBusinessAngelLoansDestroyPath = '/api/venture_funds/business-angel-loans/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelLoansDestroy$Response(
    params: VentureFundsBusinessAngelLoansDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsBusinessAngelLoansDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelLoansDestroy(
    params: VentureFundsBusinessAngelLoansDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsBusinessAngelLoansDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelLoansPartialUpdate()` */
  static readonly VentureFundsBusinessAngelLoansPartialUpdatePath = '/api/venture_funds/business-angel-loans/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelLoansPartialUpdate$Response(
    params: VentureFundsBusinessAngelLoansPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelLoansPartialUpdate(
    params: VentureFundsBusinessAngelLoansPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelLoansPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelLoansPartialUpdate$FormData$Response(
    params: VentureFundsBusinessAngelLoansPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
    return ventureFundsBusinessAngelLoansPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelLoansPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelLoansPartialUpdate$FormData(
    params: VentureFundsBusinessAngelLoansPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelLoanDto> {
    return this.ventureFundsBusinessAngelLoansPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelLoanDto>): BackendBusinessAngelLoanDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelVariantsList()` */
  static readonly VentureFundsBusinessAngelVariantsListPath = '/api/venture_funds/business-angel-variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelVariantsList$Response(
    params?: VentureFundsBusinessAngelVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelVariantListDto>> {
    return ventureFundsBusinessAngelVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelVariantsList(
    params?: VentureFundsBusinessAngelVariantsList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedBusinessAngelVariantListDto> {
    return this.ventureFundsBusinessAngelVariantsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendPaginatedBusinessAngelVariantListDto>,
        ): BackendPaginatedBusinessAngelVariantListDto => r.body,
      ),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelVariantsCreate()` */
  static readonly VentureFundsBusinessAngelVariantsCreatePath = '/api/venture_funds/business-angel-variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelVariantsCreate$Response(
    params: VentureFundsBusinessAngelVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelVariantsCreate(
    params: VentureFundsBusinessAngelVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelVariantsCreate$FormData$Response(
    params: VentureFundsBusinessAngelVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelVariantsCreate$FormData(
    params: VentureFundsBusinessAngelVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelVariantsRetrieve()` */
  static readonly VentureFundsBusinessAngelVariantsRetrievePath = '/api/venture_funds/business-angel-variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelVariantsRetrieve$Response(
    params: VentureFundsBusinessAngelVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelVariantsRetrieve(
    params: VentureFundsBusinessAngelVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelVariantsUpdate()` */
  static readonly VentureFundsBusinessAngelVariantsUpdatePath = '/api/venture_funds/business-angel-variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelVariantsUpdate$Response(
    params: VentureFundsBusinessAngelVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelVariantsUpdate(
    params: VentureFundsBusinessAngelVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelVariantsUpdate$FormData$Response(
    params: VentureFundsBusinessAngelVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelVariantsUpdate$FormData(
    params: VentureFundsBusinessAngelVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelVariantsDestroy()` */
  static readonly VentureFundsBusinessAngelVariantsDestroyPath = '/api/venture_funds/business-angel-variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelVariantsDestroy$Response(
    params: VentureFundsBusinessAngelVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsBusinessAngelVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelVariantsDestroy(
    params: VentureFundsBusinessAngelVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsBusinessAngelVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelVariantsPartialUpdate()` */
  static readonly VentureFundsBusinessAngelVariantsPartialUpdatePath =
    '/api/venture_funds/business-angel-variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelVariantsPartialUpdate$Response(
    params: VentureFundsBusinessAngelVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelVariantsPartialUpdate(
    params: VentureFundsBusinessAngelVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelVariantsPartialUpdate$FormData$Response(
    params: VentureFundsBusinessAngelVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
    return ventureFundsBusinessAngelVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelVariantsPartialUpdate$FormData(
    params: VentureFundsBusinessAngelVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelVariantDto> {
    return this.ventureFundsBusinessAngelVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelVariantDto>): BackendBusinessAngelVariantDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelsList()` */
  static readonly VentureFundsBusinessAngelsListPath = '/api/venture_funds/business-angels/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelsList$Response(
    params?: VentureFundsBusinessAngelsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelListDto>> {
    return ventureFundsBusinessAngelsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelsList(
    params?: VentureFundsBusinessAngelsList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedBusinessAngelListDto> {
    return this.ventureFundsBusinessAngelsList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedBusinessAngelListDto>): BackendPaginatedBusinessAngelListDto => r.body,
      ),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelsCreate()` */
  static readonly VentureFundsBusinessAngelsCreatePath = '/api/venture_funds/business-angels/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelsCreate$Response(
    params: VentureFundsBusinessAngelsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelsCreate(
    params: VentureFundsBusinessAngelsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelsCreate$FormData$Response(
    params: VentureFundsBusinessAngelsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelsCreate$FormData(
    params: VentureFundsBusinessAngelsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelsRetrieve()` */
  static readonly VentureFundsBusinessAngelsRetrievePath = '/api/venture_funds/business-angels/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelsRetrieve$Response(
    params: VentureFundsBusinessAngelsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelsRetrieve(
    params: VentureFundsBusinessAngelsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelsUpdate()` */
  static readonly VentureFundsBusinessAngelsUpdatePath = '/api/venture_funds/business-angels/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelsUpdate$Response(
    params: VentureFundsBusinessAngelsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelsUpdate(
    params: VentureFundsBusinessAngelsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelsUpdate$FormData$Response(
    params: VentureFundsBusinessAngelsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelsUpdate$FormData(
    params: VentureFundsBusinessAngelsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelsDestroy()` */
  static readonly VentureFundsBusinessAngelsDestroyPath = '/api/venture_funds/business-angels/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelsDestroy$Response(
    params: VentureFundsBusinessAngelsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsBusinessAngelsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsBusinessAngelsDestroy(
    params: VentureFundsBusinessAngelsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsBusinessAngelsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsBusinessAngelsPartialUpdate()` */
  static readonly VentureFundsBusinessAngelsPartialUpdatePath = '/api/venture_funds/business-angels/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelsPartialUpdate$Response(
    params: VentureFundsBusinessAngelsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsBusinessAngelsPartialUpdate(
    params: VentureFundsBusinessAngelsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsBusinessAngelsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelsPartialUpdate$FormData$Response(
    params: VentureFundsBusinessAngelsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendBusinessAngelDto>> {
    return ventureFundsBusinessAngelsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsBusinessAngelsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsBusinessAngelsPartialUpdate$FormData(
    params: VentureFundsBusinessAngelsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendBusinessAngelDto> {
    return this.ventureFundsBusinessAngelsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendBusinessAngelDto>): BackendBusinessAngelDto => r.body),
    );
  }
}
